const axios = require("axios");
const BASE_URL = process.env.REACT_APP_BASE_URL || `http://localhost:5000`;

export function remote_service_client_info(payload, user_session_id) {
  return axios.post(`${BASE_URL}/info`, {
    payload: payload,
    user_session_id: user_session_id,
  });
}

export function remote_service_session_init(payload) {
  return axios.post(`${BASE_URL}/init`, { payload: payload });
}
